import { CreditorState } from '@debbie/common/dist/creditor/index.js';
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import 'react-select-v1/dist/react-select.css';
import { useCaseFilter } from '@debbie/cortex/dist/insights/caseFilter.js';
import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { styled } from 'styled-components';
const CreditorSelector = (props) => {
    const caseFilter = useCaseFilter();
    const selectedCreditors = caseFilter.creditorIds;
    const creditorsLoadable = useAllCreditors();
    const creditors = h.hasData(creditorsLoadable) ? creditorsLoadable.data : [];
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", { style: props.style },
        React.createElement(StyledSelect, { value: (selectedCreditors || []).map((cId) => {
                const creditor = creditors.find((c) => c.creditorId === cId);
                return {
                    label: (creditor?.state && creditor.state !== CreditorState.Active
                        ? `${lang.creditors.states[creditor.state]}: `
                        : '') + (creditor?.name || 'Error: Not found'),
                    value: creditor?.creditorId,
                };
            }), isMulti: true, placeholder: lang.inputs.creditorSelect, name: "creditors", className: "creditors-select", classNamePrefix: "select", options: creditors.map((creditor) => ({
                label: (creditor?.state && creditor.state !== CreditorState.Active
                    ? `${lang.creditors.states[creditor.state]}: `
                    : '') + creditor.name,
                value: creditor.creditorId,
            })), onChange: (val) => {
                const selected = val != null ? val.map((v) => v.value) : [];
                caseFilterStore.setSelectedCreditors(selected);
                props.onChange && props.onChange(selected);
            } })));
};
export default CreditorSelector;
const StyledSelect = styled(Select) `
  & > .select__menu {
    z-index: 2;
  }
`;
//# sourceMappingURL=CreditorSelector.js.map